import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../apiAccess/PromiseStateContainer';
import BASE_URL from '../apiAccess/urls';
import { createSubheaderRow, createFullNutrientRows } from '../util/util';
import ComponentsTable from './ComponentsTable';

class FullGrouped extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    this.props.setCsvHeader([
      {label: 'Category', key: 'category'},
      {label: 'Nutrient', key: 'nutrient'},
      {label: 'Unit', key: 'unit'},
      {label: 'Quantity per Serve', key: 'qps'},
      {label: '%DI per Serve', key: 'rdi'},
      {label: 'Quantity per 100 g', key: 'qpg'},
    ]);
  }

  render() {
    const {
      unitFetch,
      carbsTotalsComponentSetFetch,
      carbsAvailableComponentSetFetch,
      carbsSugarsComponentSetFetch,
      carbsIndividualSugarsComponentSetFetch,
      carbsStarchComponentSetFetch,
      carbsUnavailableComponentSetFetch,
      carotenoidsComponentSetFetch,
      energyComponentSetFetch,
      fatsComponentSetFetch,
      mineralsComponentSetFetch,
      organicAcidsComponentSetFetch,
      proteinComponentSetFetch,
      vitaminsWaterComponentSetFetch,
      vitaminsFatComponentSetFetch,
      otherComponentSetFetch,
      fullFetch,
    } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([
          unitFetch,
          carbsTotalsComponentSetFetch,
          carbsAvailableComponentSetFetch,
          carbsSugarsComponentSetFetch,
          carbsIndividualSugarsComponentSetFetch,
          carbsStarchComponentSetFetch,
          carbsUnavailableComponentSetFetch,
          carotenoidsComponentSetFetch,
          energyComponentSetFetch,
          fatsComponentSetFetch,
          mineralsComponentSetFetch,
          organicAcidsComponentSetFetch,
          proteinComponentSetFetch,
          vitaminsWaterComponentSetFetch,
          vitaminsFatComponentSetFetch,
          otherComponentSetFetch,
          fullFetch,
        ])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([
    units,
    carbsTotalsComponentSet,
    carbsAvailableComponentSet,
    carbsSugarsComponentSet,
    carbsIndividualSugarsComponentSet,
    carbsStarchComponentSet,
    carbsUnavailableComponentSet,
    carotenoidsComponentSet,
    energyComponentSet,
    fatsComponentSet,
    mineralsComponentSet,
    organicAcidsComponentSet,
    proteinComponentSet,
    vitaminsWaterComponentSet,
    vitaminsFatComponentSet,
    otherComponentSet,
    full,
  ]) {
    const tableData = createSubheaderRow('Carbohydrates')
      .concat(createFullNutrientRows(carbsTotalsComponentSet.components, full, units))
      .concat(createSubheaderRow('Available', 2))
      .concat(createFullNutrientRows(carbsAvailableComponentSet.components, full, units))
      .concat(createSubheaderRow('Sugars', 2))
      .concat(createFullNutrientRows(carbsSugarsComponentSet.components, full, units))
      .concat(createSubheaderRow('Individual Sugars', 2))
      .concat(createFullNutrientRows(carbsIndividualSugarsComponentSet.components, full, units))
      .concat(createSubheaderRow('Starch', 2))
      .concat(createFullNutrientRows(carbsStarchComponentSet.components, full, units))
      .concat(createSubheaderRow('Unavailable', 2))
      .concat(createFullNutrientRows(carbsUnavailableComponentSet.components, full, units))
      .concat(createSubheaderRow('Carotenoids'))
      .concat(createFullNutrientRows(carotenoidsComponentSet.components, full, units))
      .concat(createSubheaderRow('Energy'))
      .concat(createFullNutrientRows(energyComponentSet.components, full, units))
      .concat(createSubheaderRow('Fats and Fatty Acids'))
      .concat(createFullNutrientRows(fatsComponentSet.components, full, units))
      .concat(createSubheaderRow('Minerals'))
      .concat(createFullNutrientRows(mineralsComponentSet.components, full, units))
      .concat(createSubheaderRow('Organic Acids'))
      .concat(createFullNutrientRows(organicAcidsComponentSet.components, full, units))
      .concat(createSubheaderRow('Protein and Amino Acids'))
      .concat(createFullNutrientRows(proteinComponentSet.components, full, units))
      .concat(createSubheaderRow('Vitamins Water Soluble'))
      .concat(createFullNutrientRows(vitaminsWaterComponentSet.components, full, units))
      .concat(createSubheaderRow('Vitamins Fat Soluble'))
      .concat(createFullNutrientRows(vitaminsFatComponentSet.components, full, units))
      .concat(createSubheaderRow('Other'))
      .concat(createFullNutrientRows(otherComponentSet.components, full, units));

    return (
      <ComponentsTable
        tableType='fullGrouped'
        tableData={tableData}
        setCsvData={this.props.setCsvData}
      />
    );
  }
}

FullGrouped.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  carbsTotalsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsAvailableComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsSugarsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsIndividualSugarsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsStarchComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsUnavailableComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carotenoidsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  energyComponentSetFetch: PropTypes.instanceOf(PromiseState),
  fatsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  mineralsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  organicAcidsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  proteinComponentSetFetch: PropTypes.instanceOf(PromiseState),
  vitaminsWaterComponentSetFetch: PropTypes.instanceOf(PromiseState),
  vitaminsFatComponentSetFetch: PropTypes.instanceOf(PromiseState),
  otherComponentSetFetch: PropTypes.instanceOf(PromiseState),
  fullFetch: PropTypes.instanceOf(PromiseState),
  recordid: PropTypes.string.isRequired,
  servingSize: PropTypes.number,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

export default connect(props => {
  let query = typeof props.servingSize === 'number' ? `?amount=${props.servingSize}&` : '?';
  return {
    unitFetch: `${BASE_URL}/unit`,
    carbsTotalsComponentSetFetch: `${BASE_URL}/component/set/13`,
    carbsAvailableComponentSetFetch: `${BASE_URL}/component/set/14`,
    carbsSugarsComponentSetFetch: `${BASE_URL}/component/set/15`,
    carbsIndividualSugarsComponentSetFetch: `${BASE_URL}/component/set/16`,
    carbsStarchComponentSetFetch: `${BASE_URL}/component/set/17`,
    carbsUnavailableComponentSetFetch: `${BASE_URL}/component/set/18`,
    carotenoidsComponentSetFetch: `${BASE_URL}/component/set/19`,
    energyComponentSetFetch: `${BASE_URL}/component/set/20`,
    fatsComponentSetFetch: `${BASE_URL}/component/set/21`,
    mineralsComponentSetFetch: `${BASE_URL}/component/set/22`,
    organicAcidsComponentSetFetch: `${BASE_URL}/component/set/23`,
    proteinComponentSetFetch: `${BASE_URL}/component/set/24`,
    vitaminsWaterComponentSetFetch: `${BASE_URL}/component/set/25`,
    vitaminsFatComponentSetFetch: `${BASE_URL}/component/set/26`,
    otherComponentSetFetch: `${BASE_URL}/component/set/27`,
    fullFetch: `${BASE_URL}/fiav/food/${props.recordid}${query}comp_group_id=12`,
  };
})(FullGrouped);



// WEBPACK FOOTER //
// ./src/components/foodDetail/FullGrouped.js